<template>
  <div class="worksheet-layout__name">
    <editable-worksheet-name
      v-if="item"
      :id="id"
      v-model="item.name"
      :is_edit="is_edit"
      class="worksheet-layout__editable"
      @on-complete="is_edit = false"
    >
      <template slot="default" slot-scope="{ value }">
        <span class="worksheet-layout__value" >{{ value || '' }}</span>
      </template>
    </editable-worksheet-name>
  </div>
</template>

<script>
  import { WorksheetService } from '@pbx/services/WorksheetService';
  import EditableWorksheetName from '@pbx/components/worksheets/_fragments/editable/name/index';

  export default {
    components: {
      EditableWorksheetName
    },
    props: {
      id: {
        type: [Number, String],
        default: null
      }
    },

    data() {
      return {
        is_edit: false,
        item: null
      };
    },

    created() {
      WorksheetService.getItem(this.id).then(item => (this.item = item));
    }
  };
</script>

<style lang="scss">
  .worksheet-layout {
    &__name {
      display: flex;
      align-items: center;
      padding: 0 16px;
      font-size: 18px;
      color: $blue-grey-light;
    }

    &__editable {
      max-width: 100%;
      display: flex;
      align-items: center;

      .ivu-input-wrapper {
        width: 100%;
        min-width: 250px;
      }
    }

    &__icon {
      margin-left: 10px;
      font-size: 18px;
    }
  }
</style>
